import * as PIXI from 'pixi.js';
import { construct } from './commonInitializer';
// import { gameTexts } from '../../gameLogic/gameTexts';

export class BitmapText extends PIXI.BitmapText {
  constructor(options) {
    super('', { fontName: options.fontName });

    // construct.call(this, options);
    if (options.text) this.text = options.text;
  }

  applyStyles(styles = {}) {
    if (Array.isArray(styles)) styles = styles.reduce((r, c) => Object.assign(r, c), {});
    // eslint-disable-next-line guard-for-in,no-restricted-syntax
    for (const prop in styles) {
      const value = styles[prop];
      // if (commonPropertySetters[prop]) commonPropertySetters[prop].call(this, value);
      // else {
      // eslint-disable-next-line default-case
      switch (prop) {
        case 'fontSize':
        case 'align':
        case 'maxWidth':
        case 'letterSpacing':
        case 'text':
          this[prop] = value;
          break;
        case 'translation':
          // this.setText(gameTexts[value]);
          break;
      }
      // }
    }
  }

  setText(value) {
    this.text = value;
  }
}
